import { LanguageEnum, type LanguageMapType } from '@models/entities/languages'

export const LANGUAGE_MAP: LanguageMapType = {
  [LanguageEnum.ru]: {
    key: LanguageEnum.ru,
    title: 'Русский',
    shortName: 'RU'
  },
  [LanguageEnum.en]: {
    key: LanguageEnum.en,
    title: 'English',
    shortName: 'EN'
  },
  [LanguageEnum.de]: {
    key: LanguageEnum.de,
    title: 'Deutsch',
    shortName: 'DE'
  },
  [LanguageEnum.ptbr]: {
    key: LanguageEnum.ptbr,
    title: 'Português',
    shortName: 'PT'
  },
  [LanguageEnum.hi]: {
    key: LanguageEnum.hi,
    title: 'हिंदी',
    shortName: 'HI'
  },
  [LanguageEnum.uk]: {
    key: LanguageEnum.uk,
    title: 'Український',
    shortName: 'UA'
  },
  [LanguageEnum.az]: {
    key: LanguageEnum.az,
    title: 'Azərbaycan',
    shortName: 'AZ'
  },
  [LanguageEnum.es]: {
    key: LanguageEnum.es,
    title: 'Español',
    shortName: 'ES'
  },
  [LanguageEnum.uz]: {
    key: LanguageEnum.uz,
    title: 'O\'zbek',
    shortName: 'UZ'
  },
  [LanguageEnum.kk]: {
    key: LanguageEnum.kk,
    title: 'Қазақ',
    shortName: 'KZ'
  },
  [LanguageEnum.bn]: {
    key: LanguageEnum.bn,
    title: 'বাংলা',
    shortName: 'BN'
  }
}
